import { store, getContext } from '@wordpress/interactivity';
import blockDef from './block.json';

export const { state, actions } = store(blockDef.amplify.viewNamespace, {
  state: {
    get selectedIndex() {
      const context = getContext();
      return context.selectedIndex;
    },
  },

  actions: {
    setSelectedIndex: (newSelectedIndex) => {
      const context = getContext();
      context.selectedIndex = newSelectedIndex;
    },
  },

  callbacks: {
    init: () => {
      const context = getContext();
      console.log(`[TabLayout#init] context:`, context);
    },
  },
});
